import { useConfigContext } from '../context/ConfigContext';

export const useConfig = () => {
  return useConfigContext();
};
